import { useSyncExternalStore } from "react"

/**
 * One MediaQueryList per query for the page (decision 0151): every chip asks `usePhone`, and `matchMedia` on every
 * render of every chip parsed the query and built a new list each time (slow in Safari).
 */
const lists = new WeakMap<object, Map<string, MediaQueryList>>()
const listOf = (query: string): MediaQueryList => {
  // keyed by the page's matchMedia, so a test that swaps it gets fresh lists
  const match = window.matchMedia
  let byQuery = lists.get(match)
  if (!byQuery) {
    byQuery = new Map()
    lists.set(match, byQuery)
  }
  let list = byQuery.get(query)
  if (!list) {
    list = window.matchMedia(query)
    byQuery.set(query, list)
  }
  return list
}

/** True while the media query matches. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = listOf(query)
      list.addEventListener("change", onChange)
      return () => list.removeEventListener("change", onChange)
    },
    () => listOf(query).matches,
    () => false,
  )
}

/** Phones: the bottom tab bar layout (< 640px). */
export const usePhone = () => useMediaQuery("(max-width: 639.98px)")

/** Below the settings/picker breakpoint (< 768px): pickers open as bottom sheets, settings nav is its own page. */
export const useNarrow = () => useMediaQuery("(max-width: 767.98px)")
